import React from 'react';
import { CenteredSpinner } from 'components/Common/CenteredSpinner';
import { useRequiredData } from './useRequiredData';


export const ContentPageWrapper = (props: { userId: number; children: React.ReactNode; }) => {
    const { client, currentUser, userGroups } = useRequiredData(props.userId);

    // console.log("ContentPageWrapper", client, currentUser, userGroups);
    if (!client || !currentUser || !userGroups) {
        return (<><CenteredSpinner /> Laddar data...</>);
    }

    return <>{props.children}</>;
};
